import React from 'react';
import { FormattedMessage } from 'react-intl/dist';
import styled from 'styled-components';

import { RELATIONSHIP_TYPES } from '../../../constants/common/relationShipTypes';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { phoneNumberTools } from '../../../utils/tools/phoneNumberTools';


const StyledContainer = styled.div`
    thead{
        border-bottom:1px solid ${({ theme }) => theme.gray4};
    }
    th:has(.display-none){
        padding: 0px !important
    }
    thead{
        th{
            text-transform: uppercase;
        }
    }
    table{
        width:100%
    }
`;

const CoveredMemberDetails = (props: { enrollmentDetails: IEnrollmentDetails }) => {
    const { enrollmentDetails } = { ...props };

    const createLabel = (key) => `indportal.enrollments.label.${key}`;
    const RELATIONSHIP_LABELS = {
        [RELATIONSHIP_TYPES.SELF.value]: createLabel('self'),
        [RELATIONSHIP_TYPES.SPOUSE.value]: createLabel('spouse'),
        [RELATIONSHIP_TYPES.FATHERORMOTHER.value]: createLabel('fatherOrMother'),
        [RELATIONSHIP_TYPES.GRANDFATHERORGRANDMOTHER.value]: createLabel('grandfatherOrGrandmother'),
        [RELATIONSHIP_TYPES.GRANDSONORGRANDAUGHTER.value]: createLabel('grandsonOrGrandaughter'),
        [RELATIONSHIP_TYPES.UNCLEORAUNT.value]: createLabel('uncleOrAunt'),
        [RELATIONSHIP_TYPES.NEPHEWORNIECE.value]: createLabel('nephewOrNiece'),
        [RELATIONSHIP_TYPES.COUSIN.value]: createLabel('cousin'),
        [RELATIONSHIP_TYPES.ADOPTEDCHILD.value]: createLabel('adoptedChild'),
        [RELATIONSHIP_TYPES.FOSTERCHILD.value]: createLabel('fosterChild'),
        [RELATIONSHIP_TYPES.SONORDAUGHTERLAW.value]: createLabel('SonOrDaughterLaw'),
        [RELATIONSHIP_TYPES.BROTHERORSISTERLAW.value]: createLabel('brotherOrSisterLaw'),
        [RELATIONSHIP_TYPES.MOTHERORFATHERLAW.value]: createLabel('motherOrFatherLaw'),
        [RELATIONSHIP_TYPES.BROTHERORSISTER.value]: createLabel('brotherOrSister'),
        [RELATIONSHIP_TYPES.WARD.value]: createLabel('ward'),
        [RELATIONSHIP_TYPES.STEPPARENT.value]: createLabel('stepparent'),
        [RELATIONSHIP_TYPES.STEPSONORDAUGHTER.value]: createLabel('stepSonOrDaughter'),
        [RELATIONSHIP_TYPES.CHILD.value]: createLabel('child'),
        [RELATIONSHIP_TYPES.SPONSOREDDEPENDENT.value]: createLabel('sponsoredDependent'),
        [RELATIONSHIP_TYPES.DEPENDENTMINORDEPENDENT.value]: createLabel('dependentMinorDependent'),
        [RELATIONSHIP_TYPES.EXSPOUSE.value]: createLabel('exSpouse'),
        [RELATIONSHIP_TYPES.GUARDIAN.value]: createLabel('guardian'),
        [RELATIONSHIP_TYPES.COURTAPPOINTEDGUARDIAN.value]: createLabel('courtAppointedGuardian'),
        [RELATIONSHIP_TYPES.COLLATERALDEPENDENT.value]: createLabel('collateralDependent'),
        [RELATIONSHIP_TYPES.LIFEPARTNER.value]: createLabel('lifePartner'),
        [RELATIONSHIP_TYPES.ANNUITANT.value]: createLabel('annuitant'),
        [RELATIONSHIP_TYPES.TRUSTEE.value]: createLabel('trustee'),
        [RELATIONSHIP_TYPES.OTHERRELATIONSHIP.value]: createLabel('otherRelationship'),
        [RELATIONSHIP_TYPES.OTHERRELATIVE.value]: createLabel('otherRelative'),
    };

    const getMemberLabel = (relationship) =>
        RELATIONSHIP_LABELS[relationship.toUpperCase()] || '';

    const getCoveredMembers = (): React.ReactElement[] => {
        return enrollmentDetails.enrolleeHistoryEntries.map((enrollee) => {
            return (
                <div key={enrollee.exchgIndivIdentifier}>
                    <span>
                        <ConditionalRendering isTrue={!!RELATIONSHIP_LABELS[enrollee?.relationship?.toUpperCase()]}>
                            <FormattedMessage id={getMemberLabel(enrollee.relationship)} />
                        </ConditionalRendering>
                    </span>
                    <span>{enrollee.name}</span>
                    <span>{enrollee.startDate} - {enrollee.endDate}</span>
                </div>
            )
        })
    }

    return (
        <StyledContainer className="col-xs-12 col-md-7 col-lg-7 covered-family-members">
            <div className='gi-table gi-usa-table' data-testid="contactYourCarrier">
                <div className='header-border'>
                    <span className='grid-header'>
                        <FormattedMessage id="indportal.enrollments.contactYourCarrier" />
                    </span>
                </div>
                <div className='grid-body'>
                    <div>
                        <span data-testid="customerService"><FormattedMessage id="indportal.enrollments.customerService" /></span>
                        <span>{phoneNumberTools.formatPhoneNumber(enrollmentDetails.issuerPhone)}</span>
                    </div>
                    <div>
                        <span data-testid="contactYourCarrierWeb"><FormattedMessage id="indportal.enrollments.web" /></span>
                        <span>
                            <ConditionalRendering isTrue={!!enrollmentDetails.issuerSite}>
                                <a href={enrollmentDetails.issuerSite} data-testid="issuerSite" target="_blank" rel="noopener noreferrer">
                                    <FormattedMessage id="indportal.enrollments.clickHere" />
                                </a>
                            </ConditionalRendering>
                        </span>
                    </div>
                </div>
            </div>
            <div className='gi-table gi-usa-table' data-testid="coveredFamilyMembers">
                <div className='header-border'>
                    <span className='grid-header'>
                        <FormattedMessage id="indportal.enrollments.coveredFamilyMembers" />
                    </span>
                </div>
                <div className='grid-body covered-family-members'>
                    {getCoveredMembers()}
                </div>
            </div>
        </StyledContainer>
    );
};

export default CoveredMemberDetails;